import { useTolgee } from "@tolgee/react";
import { ENGLISH_LANG_CODE } from "@evennt-tech/api-v2-core";
import backgroundPlaceholder from "assets/images/product/productCardPlaceholder.png";
import { usePublishedLanguages } from "hooks/usePublishedLanguages";

const useProductImagePlaceholder = (): string => {
  const tolgee = useTolgee(["language"]);
  const activeCode = tolgee.getLanguage() ?? ENGLISH_LANG_CODE;
  const { languages } = usePublishedLanguages();

  const urlByCode = (code: string) =>
    languages.find((language) => language.code === code)
      ?.productImagePlaceHolder?.url;

  return (
    urlByCode(activeCode) ??
    urlByCode(ENGLISH_LANG_CODE) ??
    backgroundPlaceholder
  );
};

export default useProductImagePlaceholder;
